export default "__VITE_ASSET__6ba559af__"